import { subActivityList } from "constants/subActivity";

const initialState = {
  subActivityList: {},
};

const subActivity = (state = initialState, action) => {
  switch (action.type) {
    case subActivityList:
      return { ...state, subActivityList: action.payload };

    default:
      return state;
  }
};
export default subActivity;
